import { render, staticRenderFns } from "./RegisterFormPartnerContact.vue?vue&type=template&id=20f6f7a7&scoped=true&"
import script from "./RegisterFormPartnerContact.vue?vue&type=script&lang=js&"
export * from "./RegisterFormPartnerContact.vue?vue&type=script&lang=js&"
import style0 from "./RegisterFormPartnerContact.vue?vue&type=style&index=0&id=20f6f7a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f6f7a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20f6f7a7')) {
      api.createRecord('20f6f7a7', component.options)
    } else {
      api.reload('20f6f7a7', component.options)
    }
    module.hot.accept("./RegisterFormPartnerContact.vue?vue&type=template&id=20f6f7a7&scoped=true&", function () {
      api.rerender('20f6f7a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/RegisterFormPartnerContact.vue"
export default component.exports